// extracted by mini-css-extract-plugin
export default {"create-new-password-page":"CreateNewPasswordPage_create-new-password-page__IRRTT"};